import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Input,
  Spacer,
  useDisclosure,
  VStack,
  Image,
  Text,
  Select,
} from "@chakra-ui/react";
import { useMarketingMaster } from "../../store/marketing/reducer";
import { REQUEST_MASTER_MARKETING } from "../../store/marketing/marketingActionTypes";
import MarketingMasterTable from "../../components/MarketingMasterTable/MarketingMasterTable";

const Marketing = () => {
  const { masterMarketing, busy } = useMarketingMaster();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: REQUEST_MASTER_MARKETING });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [searchQuery, setSearch] = useState("");

  return (
    <>
      <VStack top={5} position="relative" key={"vStack"}>
        <Flex w="92%" alignItems="center" justifyContent="space-between">
          <Heading ml="8" size="md" fontWeight="semibold" color="black.400">
            Marketing
          </Heading>
          <Spacer></Spacer>
          <Heading size="sm" fontWeight="semibold">
            <Flex alignItems="center" gap={2}>
              <Image
                borderRadius="full"
                boxSize="50px"
                src="https://bit.ly/dan-abramov"
                alt="Dan Abramov"
              />
              <Text>Admin</Text>
            </Flex>
          </Heading>
        </Flex>
      </VStack>
      <MarketingMasterTable query={searchQuery} />
    </>
  );
};

export default Marketing;
